import { useInfiniteQuery, useQueries, useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

const fetchSubCollections = async (payload) => {
  try {
    const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getAllCollectionCategories`, payload);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const fetchAiSubCollections = async (aipayload) => {
  try {
    const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getSpecificAICollectionData`, aipayload);

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const useGetCollectionCategory = (payload, aipayload, enableSubCollections, enableAiCollections) => {
  const [subCollectionsQuery, aiSubCollectionsQuery] = useQueries({
    queries: [
      {
        queryKey: ["subcollections", payload],
        queryFn: () => fetchSubCollections(payload),
        enabled: enableSubCollections,
        refetchOnWindowFocus: false,
      },
      {
        queryKey: ["aiSubcollections", aipayload],
        queryFn: () => fetchAiSubCollections(aipayload),
        enabled: enableAiCollections,
        refetchOnWindowFocus: false,
      },
    ],
  });

  return { subCollectionsQuery, aiSubCollectionsQuery };
};

const fetchDuplicateStocks = async (duplicateStockPayload) => {
  try {
    console.log("duplicateStockPayload ==>", duplicateStockPayload);
    const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getDuplicateStocks`, duplicateStockPayload);
    return {
      duplicateStocks: response.data.duplicateStocks,
      nextPage: response.data.page + 1,
      totalPages: response.data.totalPages,
      totalCount: response.data.duplicateStocksTotalCount,
    };
  } catch (error) {
    return error.response.data;
  }
};

const useGetDuplicateStocks = ({
  collectionName,
  sortBy = "",
  sortOrder = "desc",
  searchTerm = "",
  limit = 20,
  Class = [],
  location = [],
  stockStatus = "",
  restricted = false,
  rangeStock = null,
  category = "",
}) => {
  // const enabled = collectionName === "Duplicate Stocks" || collectionName === "Restricted Stock" || collectionName.endsWith("Stock");
  const enabled = (collectionName === "Duplicate Stocks" || collectionName === "Restricted Stock" || collectionName.endsWith("Stock")) && location?.length > 0;
  console.log("rangeStock ==>", rangeStock);
  return useInfiniteQuery({
    queryKey: ["duplicateStocksPage", { collectionName, sortBy, sortOrder, searchTerm, limit, Class, location, stockStatus, restricted, rangeStock, category }],
    queryFn: ({ pageParam = 1 }) =>
      fetchDuplicateStocks({
        page: pageParam,
        sortBy,
        sortOrder,
        searchTerm,
        limit,
        Class,
        location,
        stockStatus,
        restricted,
        rangeStock,
        category,
      }),
    enabled,
    getNextPageParam: (lastPage) => {
      if (lastPage?.nextPage <= lastPage?.totalPages) {
        return lastPage?.nextPage;
      }
      return undefined;
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};

// const useGetCollectionCategory = (payload, aipayload) => {
//   return useQuery({
//     queryKey: ["subcollections", payload],
//     queryFn: () => fetchSubCollections(payload),
//     enabled: !!payload,
//     refetchOnWindowFocus: false,
//   });
// };

export { useGetCollectionCategory, useGetDuplicateStocks };
